const normalizeFinish = (value) =>
  String(window.PanoSoraCanonicalText(value) || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const finishColor = (value, productHandle = '') => {
  const key = normalizeFinish(value);
  productHandle = window.PanoSoraCanonicalHandle(productHandle);
  if (productHandle === 'panneau-mural-decoratif-bois' && key === 'chene americain') return '#cac5bc';
  if (productHandle === "panneau-acoustique-mural-larges-tasseaux-bois") {
    const wideSlatColors = {"chene naturel":"#b48454","chene bronze":"#6f4726","chene fume":"#3c2a1f","noyer":"#744931","frene graphite":"#2f2f2f"};
    if (wideSlatColors[key]) return wideSlatColors[key];
  }
  if (productHandle === 'panneau-mural-tissu-decoratif') {
    const fabricColors = {
      beige: '#cbc0b1',
      sable: '#ab7728',
      'gris clair': '#cececd',
      gris: '#5c5955',
      olive: '#6c622b',
      marron: '#513422',
      'bleu marine': '#222b3f',
      'rouge fonce': '#671f29',
    };
    return fabricColors[key] || '#b8b0a4';
  }
  if (key.includes('frene noir')) return '#242424';
  if (key === 'noir') return '#3f3f3f';
  if (key.includes('frene graphite') || key === 'graphite') return '#707070';
  if (key.includes('noyer')) return '#5a3825';
  if (key.includes('chene fume')) return '#6b5541';
  if (key.includes('chene bronze') || key.includes('bronze')) return '#8b6847';
  if (key.includes('chene gris fonce')) return '#5c5a55';
  if (key === 'gris fonce') return '#4e4f5d';
  if (key.includes('chene blanchi')) return '#d7c8ac';
  if (key.includes('blanc lait')) return '#f2f0e9';
  if (key.includes('chene moka')) return '#8d6d63';
  if (key.includes('chene clair') || key === 'chene') return '#c7a87a';
  if (key.includes('chene naturel') || key.includes('naturel')) return '#c6a878';
  if (key.includes('liege')) return '#b88959';
  if (key === 'beige') return '#c8b89a';
  if (key === 'ecru') return '#ebe5de';
  if (key === 'grege') return '#908181';
  if (key === 'sable') return '#dba23a';
  if (key === 'caramel') return '#f5931c';
  if (key === 'terracotta') return '#c83a57';
  if (key === 'brun') return '#752908';
  if (key === 'mousse') return '#789c5d';
  if (key.includes('gris clair')) return '#d9d8d8';
  if (key === 'olive') return '#6b6b15';
  if (key === 'marron') return '#513422';
  if (key.includes('bleu marine')) return '#222b3f';
  if (key.includes('rouge fonce')) return '#671f29';
  if (key === 'vert') return '#20754f';
  if (key.includes('vert foret')) return '#0a4d37';
  if (key.includes('bleu ciel')) return '#e3e6fd';
  if (key === 'bleu') return '#1c72dd';
  if (key.includes('bleu nuit')) return '#000d82';
  if (key.includes('blanc')) return '#ffffff';
  if (key.includes('gris')) return '#8b8da0';
  return '#a88a68';
};

const previewImageForProduct = (product, finish, fallback) => {
  if (product && product.handle === 'panneau-mural-tissu-decoratif') {
    const finishKey = normalizeFinish(finish).replace(/\s+/g, '-');
    const correctedFabricImages = {"sable": "https://cdn.shopify.com/s/files/1/1028/9643/5535/files/panneau-mural-tissu-sable-01-salon-nuancier-20261022.webp?v=1792655391", "gris": "https://cdn.shopify.com/s/files/1/1028/9643/5535/files/panneau-mural-tissu-gris-01-salon-nuancier-20261022.webp?v=1792655390"};
    if (correctedFabricImages[finishKey]) return correctedFabricImages[finishKey];
    return '/cdn/shop/t/3/assets/panneau-mural-tissu-' + finishKey + '-01-salon.webp';
  }
  return fallback;
};

const ensureFallbackSwatchesStyles = () => {
  if (document.getElementById('panosora-product-card-fallback-swatches')) return;

  const style = document.createElement('style');
  style.id = 'panosora-product-card-fallback-swatches';
  style.textContent = `
    product-card-swatches .panosora-finish-swatches {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 7px;
      margin-top: 4px;
      padding: 2px 2px 4px;
      min-height: 25px;
      overflow: visible;
    }
    product-card-swatches .panosora-finish-swatch {
      width: 19px;
      height: 19px;
      min-width: 19px;
      padding: 0;
      border: 1px solid #c8c8c8;
      border-radius: 50%;
      background: var(--finish-color);
      box-shadow: inset 0 0 0 2px #fff;
      cursor: pointer;
      transition: transform .15s ease, box-shadow .15s ease;
    }
    product-card-swatches .panosora-finish-swatch:hover {
      transform: scale(1.08);
    }
    product-card-swatches .panosora-finish-swatch[aria-pressed='true'] {
      border-color: #182331;
      box-shadow: inset 0 0 0 2px #fff, 0 0 0 1px #182331;
    }
    product-card-swatches .panosora-finish-swatch:focus-visible,
    product-card-swatches .panosora-finish-more:focus-visible {
      outline: 2px solid #182331;
      outline-offset: 2px;
    }
    product-card-swatches .panosora-finish-more {
      color: #182331;
      font-size: 12px;
      font-weight: 600;
      line-height: 19px;
      white-space: nowrap;
      text-decoration: none;
    }
    product-recommendations product-card-swatches {
      display: block;
      width: 100%;
      min-height: 25px;
      overflow: visible;
    }
    product-recommendations .product-card-group {
      overflow: visible;
    }
    @media (max-width: 749px) {
      product-card-swatches .panosora-finish-swatches {
        gap: 3px;
        padding: 1px;
      }
      product-card-swatches .panosora-finish-swatch {
        width: 15px;
        height: 15px;
        min-width: 15px;
        box-shadow: inset 0 0 0 1px #fff;
      }
      product-card-swatches .panosora-finish-swatch[aria-pressed='true'] {
        box-shadow: inset 0 0 0 1px #fff, 0 0 0 1px #182331;
      }
      product-card-swatches .panosora-finish-more {
        font-size: 11px;
        line-height: 15px;
      }
    }
  `;
  document.head.appendChild(style);
};

const sizedImage = (src, width) => {
  try {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('width', width);
    return url.toString();
  } catch (_) {
    return src;
  }
};

const productDataCache = new Map();

const getProductData = (productPath) => {
  const productJsonUrl = productPath.replace(/\/$/, '') + '.js';
  if (!productDataCache.has(productJsonUrl)) {
    const request = fetch(productJsonUrl, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('product unavailable');
        return response.json();
      })
      .catch((error) => {
        productDataCache.delete(productJsonUrl);
        throw error;
      });
    productDataCache.set(productJsonUrl, request);
  }
  return productDataCache.get(productJsonUrl);
};

const updateNativeSwatchPreview = async (card, swatch) => {
  const variantUrl = new URL(swatch.dataset.href || '', window.location.origin);
  const variantId = variantUrl.searchParams.get('variant');
  if (!variantId) return;

  const cardUrl = variantUrl.pathname + variantUrl.search;
  card.dataset.productUrl = cardUrl;
  card.productUrl = cardUrl;
  card.dataset.panosoraPendingVariant = variantId;
  card
    .querySelectorAll('a.product-card-group-link, a.product-card-media-gallery__link')
    .forEach((link) => {
      link.href = cardUrl;
    });

  const product = await getProductData(variantUrl.pathname);
  if (card.dataset.panosoraPendingVariant !== variantId) return;

  const variant = (product.variants || []).find(
    (item) => String(item.id) === String(variantId)
  );
  const variantImage =
    variant &&
    variant.featured_image &&
    (variant.featured_image.src || variant.featured_image);
  const imageSource = previewImageForProduct(
    product,
    variant && variant.options && variant.options[0],
    variantImage
  );
  if (!imageSource) return;

  const media = card.querySelector('product-card-media-gallery');
  const firstTab = media && media.querySelector('[role="tab"]');
  if (firstTab && firstTab.getAttribute('aria-selected') !== 'true') firstTab.click();

  const image = media && media.querySelector('.splide__slide:first-child img, img');
  if (!image) return;

  image.src = sizedImage(imageSource, 1200);
  image.srcset = [320, 480, 720, 1080]
    .map((width) => sizedImage(imageSource, width) + ' ' + width + 'w')
    .join(', ');
  image.alt = product.title + ' – ' + variant.title;

  const picture = image.closest('picture');
  if (picture) {
    picture.querySelectorAll('source').forEach((source) => {
      source.srcset = image.srcset;
    });
  }
};

class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeyDown);
    this.#enhanceCard();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeyDown);
  }

  #onClick = (event) => {
    const swatch = event.target.closest('[data-href]');
    if (!swatch || !this.contains(swatch)) return;

    event.preventDefault();
    event.stopPropagation();

    this.querySelectorAll('[data-href]').forEach((item) => {
      item.removeAttribute('aria-checked');
    });
    swatch.setAttribute('aria-checked', 'true');

    const card = this.closest('product-card');
    if (!card) return;
    updateNativeSwatchPreview(card, swatch).catch(() => {});
  };

  #onKeyDown = (event) => {
    const swatch = event.target.closest('[data-href]');
    if (!swatch || !this.contains(swatch) || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    swatch.click();
  };

  async #enhanceCard() {
    const isProductRecommendation = Boolean(this.closest('product-recommendations'));
    if (!isProductRecommendation && window.location.pathname !== '/') return;

    const card = this.closest('product-card');
    if (!card || card.dataset.panosoraFinishSwatches) return;
    card.dataset.panosoraFinishSwatches = 'loading';

    try {
      const productUrl = new URL(card.dataset.productUrl || '', window.location.origin);
      const currentVariantId = productUrl.searchParams.get('variant');
      productUrl.search = '';
      productUrl.pathname = productUrl.pathname.replace(/\/$/, '') + '.js';

      const response = await fetch(productUrl.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('product unavailable');
      const product = await response.json();

      const optionNames = (product.options || []).map((option) =>
        normalizeFinish(typeof option === 'string' ? option : option.name)
      );
      const optionIndex = optionNames.findIndex((name) =>
        ['finition', 'couleur', 'coloris', 'teinte', 'matiere'].includes(name)
      );
      if (optionIndex < 0) throw new Error('no finish option');

      const currentVariant =
        (product.variants || []).find((variant) => String(variant.id) === String(currentVariantId)) ||
        (product.variants || [])[0];
      const finishNames = [];
      (product.variants || []).forEach((variant) => {
        const name = variant.options && variant.options[optionIndex];
        if (name && !finishNames.includes(name)) finishNames.push(name);
      });

      const finishes = finishNames
        .map((name) => {
          const matching = (product.variants || []).filter(
            (variant) => variant.options && variant.options[optionIndex] === name
          );
          const sameFormat = matching.find((variant) =>
            !currentVariant ||
            variant.options.every(
              (value, index) => index === optionIndex || value === currentVariant.options[index]
            )
          );
          const variant = sameFormat || matching[0];
          const variantImage =
            variant &&
            variant.featured_image &&
            (variant.featured_image.src || variant.featured_image);
          const image = previewImageForProduct(product, name, variantImage);
          return variant ? { name, image, id: variant.id } : null;
        })
        .filter(Boolean);

      if (finishes.length < 2) throw new Error('single finish');

      ensureFallbackSwatchesStyles();
      const visibleLimit = 5;
      const displayedFinishes = finishes.slice(0, visibleLimit);

      const hosts = [...card.querySelectorAll('product-card-swatches')];
      const host = hosts[0];
      if (!host) throw new Error('missing swatch host');
      hosts.slice(1).forEach((duplicate) => {
        duplicate.style.display = 'none';
      });

      const list = document.createElement('div');
      list.className = 'panosora-finish-swatches';
      list.setAttribute('role', 'group');
      list.setAttribute('aria-label', window.PanoSoraT('Choisir la finition'));

      const media = card.querySelector('product-card-media-gallery');
      const setFinish = (finish, button) => {
        list.querySelectorAll('.panosora-finish-swatch').forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });

        const firstTab = media && media.querySelector('[role="tab"]');
        if (firstTab && firstTab.getAttribute('aria-selected') !== 'true') firstTab.click();

        const image = media && media.querySelector('.splide__slide:first-child img, img');
        if (image && finish.image) {
          image.src = sizedImage(finish.image, 1200);
          image.srcset = [320, 480, 720, 1080]
            .map((width) => sizedImage(finish.image, width) + ' ' + width + 'w')
            .join(', ');
          image.alt = product.title + window.PanoSoraT(' – finition ') + finish.name;

          const picture = image.closest('picture');
          if (picture) {
            picture.querySelectorAll('source').forEach((source) => {
              source.srcset = image.srcset;
            });
          }
        }

        const variantUrl =
          productUrl.pathname.replace(/\.js$/, '') + '?variant=' + finish.id;
        card.dataset.productUrl = variantUrl;
        card.productUrl = variantUrl;
        card
          .querySelectorAll(
            'a.product-card-group-link, a.product-card-media-gallery__link'
          )
          .forEach((link) => {
            link.href = variantUrl;
          });
      };

      displayedFinishes.forEach((finish) => {
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'panosora-finish-swatch';
        swatch.setAttribute('aria-label', finish.name);
        swatch.setAttribute('title', finish.name);
        swatch.setAttribute('aria-pressed', 'false');
        swatch.style.setProperty('--finish-color', finishColor(finish.name, product.handle));

        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          setFinish(finish, swatch);
        });
        list.appendChild(swatch);
      });

      if (finishes.length > visibleLimit) {
        const more = document.createElement('a');
        more.className = 'panosora-finish-more';
        more.href = productUrl.pathname.replace(/\.js$/, '');
        more.textContent = `+${finishes.length - visibleLimit}`;
        more.setAttribute(
          'aria-label',
          `${window.PanoSoraT("Voir les ")}${finishes.length - visibleLimit} autres teintes`
        );
        more.setAttribute('title', window.PanoSoraT('Voir toutes les teintes'));
        list.appendChild(more);
      }

      host.replaceChildren(list);
      card.dataset.panosoraFinishSwatches = 'true';

      const initial =
        displayedFinishes.find((finish) => String(finish.id) === String(currentVariantId)) ||
        displayedFinishes[0];
      const initialIndex = displayedFinishes.indexOf(initial);
      const initialButton = list.querySelectorAll('.panosora-finish-swatch')[initialIndex];
      setFinish(initial, initialButton);
    } catch (_) {
      delete card.dataset.panosoraFinishSwatches;
    }
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
